import { render } from "./m-prediction.vue?vue&type=template&id=2e1f8eb9&scoped=true&ts=true"
import script from "./m-prediction.vue?vue&type=script&lang=ts"
export * from "./m-prediction.vue?vue&type=script&lang=ts"

import "./m-prediction.vue?vue&type=style&index=0&id=2e1f8eb9&lang=scss&scoped=true"

import exportComponent from "D:\\project\\haocai\\h5\\kousai-group\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2e1f8eb9"]])

export default __exports__